export const EDGE_EDIT_BAR_OPTIONS = {
	DESIGN_SETTINGS: {VALUE: 'DESIGN_SETTINGS', TYPE: 'DESIGN_SETTINGS', ICON: 'fas fa-pencil-ruler', ACTION: null},
	VISIBILITY: {VALUE: 'VISIBILITY', TYPE: null, ICON: 'fas fa-low-vision', ACTION: null},
	CONTENT: {VALUE: 'CONTENT', TYPE: null, ICON: 'fas fa-paragraph', ACTION: null},
	DELETE: {VALUE: 'DELETE', TYPE: null, ICON: 'fas fa-trash', ACTION: 'DELETE'},
	// LOCKED: {VALUE: 'LOCKED', TYPE: null, ICON: 'fas fa-lock', ACTION: 'LOCKED'},
}
